import { getFeedbacks, Feedback } from "@api";
import { FilterType, Table, Form } from "@components";
import { Cell, Row } from "@components/table/types";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { useHistory } from "react-router-dom";
import { M_TABLE_HEADERS_FEEDBACKS } from "../constants";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { convertToRaw, EditorState } from "draft-js";
import { sub } from "date-fns";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { FeedbackDetail } from "./detail";
import { useEffect } from "react";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import parse from 'html-react-parser';

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_FEEDBACKS.FEEDBACK_ID },
  { data: M_TABLE_HEADERS_FEEDBACKS.FEEDBACK_TYPE },
  { data: M_TABLE_HEADERS_FEEDBACKS.DETAILS },
  { data: M_TABLE_HEADERS_FEEDBACKS.STATUS },
  { data: M_TABLE_HEADERS_FEEDBACKS.DATETIME_ADDED },
  { data: M_TABLE_HEADERS_FEEDBACKS.SENT_BY },
  { data: M_TABLE_HEADERS_FEEDBACKS.SUBJECT },
  { data: M_TABLE_HEADERS_FEEDBACKS.BUSINESS_UNIT },
];

const formatBool = (status: boolean): string => {
  return status ? "Yes" : "No";
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

type FormValues = {
  id: number;
  feedbackId: string;
  feedbackType: string;
  status: string;
  dateTimeAdded: string;
  sentBy: string;
  feedbackSubject: string;
  businessUnit: string;
  details: string;
  screenshotURL: string;
};

export type SelectedItem = {
  selectedEnv: Feedback;
};

type Key = keyof FormValues;

export const FeedbackList: React.FC = () => {
  const [environmentList, setEnvironment] = useState<Row<Feedback>[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [open, setOpen] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<
    Feedback | undefined
  >(undefined);
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const [startDate, setStartDate] = React.useState<MaterialUiPickersDate>(
    sub(new Date(), { days: 30 })
  );

  const [endDate, setEndDate] = React.useState<MaterialUiPickersDate>(
    new Date()
  );

  const updateData = () => {
    incrementCounter();
  };

  const handleClose = () => {
    setSelectedItem(undefined);
    setOpen(false);
  };

  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const [counter, updateCounter] = React.useState(0);
  React.useEffect(() => {
    getFeedbackValues(startDate, endDate);
  }, [counter]);
  
  const getFeedbackValues = React.useCallback((startDate: MaterialUiPickersDate, endDate: MaterialUiPickersDate) => {
    const dateStart = new Date(startDate!.toString()).toISOString().slice(0, 10);
    const dateEnd = new Date(endDate!.toString()).toISOString().slice(0, 10);
    var tomorrow = new Date(dateEnd);
    tomorrow.setDate(new Date(dateEnd).getDate()+1);
    getFeedbacks(new Date(dateStart), new Date(tomorrow) ).then((req: Feedback[]) => {
      const requestsResponse = (req || []).map((r: Feedback, index) => {
        return {
          cells: [
            {
              data: r.feedbackId.toString(),
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedItem(r);
                setOpen(true);
              },
            },
            { data: r.feedbackType },
            { data: parse(r.details) },
            { data: r.status },
            { data: r.dateTimeAdded },
            { data: r.sentBy },
            { data: r.feedbackSubject },
            { data: r.businessUnit },
          ],
          data: r,
        };
      });
      setEnvironment(requestsResponse);
      setIsloading(false);
    });
  }, [counter]);

  const incrementCounter = () => {
    updateCounter(counter + 1);
  };

  function handleDateValueChange(
    name: string,
    value: MaterialUiPickersDate
  ): void {
    console.info(value);
    if (name === "startDate") {
      setStartDate(value);
      getFeedbackValues(value, endDate);
    }

    if (name === "endDate") {
      setEndDate(value);
      getFeedbackValues(startDate, value);
    }
  }

  const onUpdateDate = React.useCallback(
     (name: string, value: MaterialUiPickersDate) => {
      if (name === "startDate") {
        setStartDate(value);
        getFeedbackValues(value, endDate);
      }
  
      if (name === "endDate") {
        setEndDate(value);
        getFeedbackValues(startDate, value);
      }
    },
    []
  );

  let editModal = null;
  if (!!selectedItem) {
    editModal = (
      <FeedbackDetail
        id={0}
        data={selectedItem}
        isOpen={open}
        onClickAdd={updateData}
        onClickClose={handleClose}
      />
    );
  }

  const pageName = "Feedback";
  return (
    <Box mt={2}>
      {/* <MaintenanceBreadcrumbs title={pageName} /> */}
     
      
      {editModal}
      <Table
        data={environmentList}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_FEEDBACKS.FEEDBACK_ID]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="FEEDBACK_TOOLBAR"
        onSearchDate={onUpdateDate}
        onClickAdd={incrementCounter}
        loading={isLoading}
      />
    </Box>
  );
};
